
export const extraToppings = (s, extraToppings) => {
	$("#" + s + "_extraToppiings").empty();
	extraToppings.forEach((etopp) => {
		let tr_extra = `
        <tr class="col-sm-12 col-xs-12 col-md-12 col-lg-12" key="${etopp.def_ing_id}" id="${s +
        "-current_" +
        etopp.def_ing_id}"
        v-show="${etopp.def_ing_name}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="add_item" id="${s +
                "_addBtn_" +
                etopp.def_ing_id}"><i class="icon_plus_alt2"  @click.prevent="addCurrentToppings(${s},${
        etopp.def_ing_id
        })"></i></a> 
        </td>
        <td 
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:140px" id="${s +
            "_et_topping_name_" +
            etopp.def_ing_id}">
            ${etopp.def_ing_name}
        </td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
            <strong class="pull-right"><span id="${s +
                "_et_price_" +
                etopp.def_ing_id}">
            ${etopp.def_topp_price}</span> </strong>
        </td>
        </tr>
        `;
		$("#" + s + "_extraToppiings").append(tr_extra);
	});
};
export const addToppings = (s,i, ETToppingName,ETPrice) => {
    var html = `
        <tr class="${s+'_extra'} col-sm-12 col-xs-12 col-md-12 col-lg-12" id="${s+'_addedExtraToppings_'+i}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="remove_item" 
                id="${s+'_removeItem_'+i}"><i class="icon_minus_alt2"></i>
            </a>
        </td>
        <td  
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:100px" id="${s+'_addedExtraToppingsName_'+i}">${ETToppingName}</td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2"><strong class="pull-right"><span id="${s+'_addedExtraToppingPrice_'+i}">${ETPrice}</span></strong></td>
        </tr>
    `;
    $("#"+s+'_defaultToppiings').prepend(html);
}
export const removeToppings = (s,i, ETToppingName,ETPrice) => {
    var html = `
        <tr class="${s+'_extra'} col-sm-12 col-xs-12 col-md-12 col-lg-12" id="${s+'-current_'+i}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="add_item" 
                id="${s+'_addBtn_'+i}"><i class="icon_plus_alt2"></i>
            </a>
        </td>
        <td  
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:100px" id="${s+'_et_topping_name_'+i}">${ETToppingName}</td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2"><strong class="pull-right"><span id="${s+'_et_price_'+i}">${ETPrice}</span></strong></td>
        </tr>
    `;
    $("#"+s+'_extraToppiings').prepend(html);
}

export const defaultToppings = (s, defaultToppings) => {
	$("#" + s + "_defaultToppiings").empty();
	defaultToppings.forEach((dtopp) => {
		let tr = `
        <tr key="${"defaultToppings_" + dtopp.def_ing_id}"
            id="${s + "-default_" + dtopp.def_ing_id}"
            class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            v-show="dtopp.def_ing_name"
            class="db_defaultToppings">
            <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
                    <a href="javascript:void(0)" class="remove_item"
                    id="${s + "_removeCurrentToppingBtn_" + dtopp.def_ing_id}"
                    @click.prevent="removeCurrentToppings(${(s,
					dtopp.def_ing_id)})"><i class="icon_minus_alt2"></i></a> 
            </td>
            <td 
            class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
            style="width:140px" id="${s +
                "_ct_topping_name_" +
                dtopp.def_ing_id}">
                    ${dtopp.def_ing_name}
                </td>
            <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
                <strong class="pull-right"><span id="${s +
                "_ct_price_" +
                dtopp.def_ing_id}">
                    ${dtopp.def_topp_price}</span></strong>
            </td>
        </tr>
        `;
		$("#" + s + "_defaultToppiings").append(tr);
	});
};
export const cartItem = (orders) => {
	$("#cartItems").empty();
	orders.forEach((items) => {
		let orderMenu = `
          <div class="col-lg-12" style="border: 1px solid #ceccccf7;border-radius: 4px;margin: 5px 0px 0px 0px;padding-bottom: 5px;padding-right: 15px;margin: 3px 5px 0;width: 96%;position: relative;box-shadow: 1px 1px 2px 2px #d2d1d1ad;">
        <div style="position: absolute; right:15px; top:8px ">
          <a href="javascript:void(0)" class="remove_item" id="menuItem_${
				items.id
			}" @click.prevent="deleteMenuItem(${items.menu_slug},${
			items.menu_price
		},${items.id},${items.order_id})"><i class="fa fa-trash"></i></a>
        </div>
        <div>
        <div class="cart-item">
          <strong> ${items.menu_name} </strong>   
        </div>
        <div class="cart-item" style="width:100%; padding:4px 0px;font-size: 13px;">
          
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding:0px">
          ${items.menu_size} - ${items.menu_qty} x ${items.menu_price}  
          <div class="pull-right">${"$ " + items.final_menu_price}</div>
          </div>
          <div class="clearfix"></div>
          <div style="display:${
				items.total_toppings_price == "0.00" ? "none" : "block"
			}">  
          Toppings Price  <div class="pull-right">${"$ " +
				items.total_toppings_price}</div>
          </div>
        </div>
        </div>
      </div>
      `;
		$("#cartItems").append(orderMenu);
	});
};
export const subTotal = (sub_total) => {
    $("#sub_total").text("");
	$("#sub_total").text("$ " + sub_total);
};

export const deliveryAmount = (delivery_amount) => {
	$("#delivery_amount").text("");
    $("#delivery_amount").text("$ " + delivery_amount);
};
export const totalAmount = (total_amount) => {
	$("#total_amount").text("");
	$("#total_amount").text("$ " + total_amount);
};
export const myOrders = (order) => {
	let html = `
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="background: rgb(255, 255, 255);
        box-shadow: 1px 1px 2px 2px rgba(0,0,0,0.11);
        padding: 10px 15px;
        border-radius:5px;
        min-height: auto !important;
        margin-bottom: 10px;">
        
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:14px; font-weight: bold;padding-left:0">
        <i class="fa fa-first-order" aria-hidden="true"></i> Order No
        <span style="margin-left:6px;"><b>${order.order_no} - ${"$ " + order.total_amount.toFixed(2)}</b></span>
        <span class="pull-right">${order.status}</span>
        </div>
        <div class="clearfix"></div>
        <hr style="margin:10px 0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding-left:0; padding-right: 0">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" 
            style="font-size:13px; padding-left:0">
            
            <span class="fa fa-eye btn btn-sm btn-block btn-success" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Open Details" 
            data-id="${order.order_no}"
            id="${"openOrder_" + order.order_no}"
            >
            Open Details
            </span>
            
            <span class="fa fa-eye-slash  btn btn-sm btn-danger btn-block" 
            style="cursor: pointer; display: none; letter-spacing:1px; margin-top:0px" 
            title="Close Details" 
            id="${"closeOrder_" + order.order_no}"
            data-id="${order.order_no}"
            >
            Close Details
            </span>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" 
            style="font-size:13px;  padding-left:0; padding-right:0; font-size:15px; letter-spacing:1px"> 
            <a href="${
                order.receipt_url
            }" target="_blank" class="btn btn-sm btn-danger btn-block" style="color: #fff;" title="view_recipet">
            <span class="fa fa-print"></span> View Recipt
            </a>
            </div>
        </div>
        
        <div class="clearfix"></div>
            
        <div class="col-lg-12" id="${
			order.order_no
		}" style="display:none; padding:0px"> 
        <hr style="margin:10px 0">
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Payer ID 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.payerID}</b>
            </div>
        </div>
        
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Order Date 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.created_at}</b>
            </div>
        </div>

        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Delivery Type
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.delivery_type}</b>
            </div>
        </div>
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Delivery Fee 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.delivery_amount.toFixed(2)}</b>
            </div>
        </div>
        
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px;padding:10px 0px">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Sub Total  
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.sub_total.toFixed(2)}</b>
            </div>
        </div>

        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Grand Total  
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.total_amount.toFixed(2)}</b>
            </div>
        </div>
        <div class="clearfix"></div>
        <h4 style="font-size:13px; font-weight: bold">Menu Details</h4>
        <hr style="margin:3px 0">
        <div class="table-responsive">
            <table class="table table-bordered table-responsive" style="width:1500px;">
                <thead>
                    <tr style="font-weight: bold; font-size: 13px">
                        <td>Menu Items</td>
                        <td>Menu Size</td>
                        <td>Menu Qty</td>
                        <td>Price</td>
                        <td>Menu Price</td>
                        <td>Top Price</td>
                        <td>Total</td>
                        <td>Toppings</td>
                    </tr>
                </thead>
                <tbody id="menuItemDetails_${order.order_no}">
                    
                </tbody>
            </table>
        </div>
    </div>
    `;
	$("#myOrders").append(html);
};

export const menuItemDetails = (menu,order_no) => {
	let hmtl = `
    <tr style="font-size: 14px">
        <td>${menu.menu_name}</td>
        <td>${menu.menu_size}</td>
        <td>${menu.menu_qty}</td>
        <td>${"$" + menu.menu_price.toFixed(2)}</td>
        <td>${"$" + (menu.menu_price * menu.menu_qty).toFixed(2)}</td>
        <td>${"$" + menu.selcetdToppings[0].def_ing_price.toFixed(2)}</td>
        <td>${"$" + menu.total_menu_price.toFixed(2)}</td>
        <td>${menu.selcetdToppings[0].def_ing_name}</td>
    </tr>
    `;
	$("#menuItemDetails_" + order_no).append(hmtl);
};

